import React from "react";
import { formatDateToLocalDate } from "../../../shared/utils";
import { addDecimalPoints } from "../../../../../js/shared/utils";

const MyPassengersTable = ({ passengers } = props) => (
	<table className="my-passengers-log-list-table">
		<thead className="my-passengers-log-list-table__header">
			<tr>
				<th>Transação</th>
				<th>Passageiro</th>
				<th>Tipo</th>
				<th>Data de emissão</th>
				<th>Qtd. de milhas</th>
			</tr>
		</thead>
		<tbody>
			{passengers.map((passenger, index) => (
				<tr key={index}>
					<td>
						<strong>{passenger.idtransactions}</strong>
					</td>
					<td>
						<strong>{passenger.name}</strong>
					</td>
					<td>
						<strong>
							{passenger.passengerType === 1
								? "Adulto"
								: passenger.passengerType === 2
									? "Criança"
									: passenger.passengerType === 3
										? "Bebê"
										: ""}
						</strong>
					</td>
					<td>
						<strong>{formatDateToLocalDate(passenger.issueDate)}</strong>
					</td>
					<td>
						<strong>{addDecimalPoints(passenger.totalMiles)}</strong>
					</td>
				</tr>
			))}
		</tbody>
	</table>
);

export default MyPassengersTable;
